import { type FC, type MouseEventHandler, type Ref } from 'react';

import { X } from 'lucide-react';

import { GenericButton } from '@shared/components/ui/custom';
import { cn } from '@shared/utils/tailwind.utils';

interface FilteringModalHeaderProps {
  onClose: () => void;
  isError?: boolean;
  dragHandleRef?: Ref<HTMLButtonElement>;
  onDragMouseDown?: MouseEventHandler<HTMLButtonElement>;
}

export const FilteringModalHeader: FC<FilteringModalHeaderProps> = ({
  onClose,
  isError,
  dragHandleRef,
  onDragMouseDown,
}) => (
  <div className="flex items-center justify-between px-4 py-3" data-testid="trace-findings-filtering-modal-header">
    <button
      ref={dragHandleRef}
      type="button"
      tabIndex={0}
      aria-label="Move filter modal"
      className={cn(
        'filtering-modal-header cursor-grab w-full text-left select-none bg-transparent border-0 p-0 font-normal outline-none leading-6',
        isError ? 'text-muted-foreground' : 'text-white',
      )}
      onMouseDown={onDragMouseDown}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
        }
      }}
      data-testid="filtering-modal-drag-handle"
    >
      Select Fields to Filter by
    </button>

    <GenericButton
      type="button"
      aria-label="Close"
      icon={X}
      variant="ghost"
      onClick={onClose}
      className="flex-none ml-auto"
      data-testid="trace-findings-filtering-modal-close-button"
    />
  </div>
);
